import React from 'react';
import { default as __ } from '../../../utils';
import { colors } from '../../../styles';
import PowerBar from './bar-power';
import PowerBarVertical from './bar-power-vertical';
import Avatar from '../../../components/padel/avatar';
import Pinned from '../../../components/utils/pinned';
import MvpBar from './bar-mvp';

function Slot(player) {
  const { id, power, team, you } = player;
  const isLandscape = __.useMediaQuery('(orientation: landscape)');
  const [theme, setTheme] = __.usePersistedState('theme', colors.accent);
  if (__.isEmptyObject(player))
    return <div className="col-center align-center " />;

  if (you) {
    return (
      <div
        key={id}
        builder-widget="slot"
        className="col-center align-center txt-pointer owl"
      >
        <Avatar.Regular shade={theme} variant="you" />
        <MvpBar />
      </div>
    );
  } else {
    return (
      <div
        key={id}
        builder-widget="slot"
        className="col-center align-center txt-pointer"
      >
        {isLandscape ? (
          <PowerBar power={power} xndxx={id} />
        ) : (
          <PowerBarVertical power={power} xndxx={id} />
        )}

        {isLandscape ? (
          <Pinned tag="div" isCenteredX offsetY="80px">
            <Avatar.Regular
              variant={!team ? 'rivals' : 'team'}
              shade="var(--ultrapurple)"
            />
          </Pinned>
        ) : (
          <Pinned tag="div" isCenteredX offsetY="140px">
            <Avatar.Small
              variant={!team ? 'rivals' : 'team'}
              shade="var(--ultrapurple)"
            />
          </Pinned>
        )}
      </div>
    );
  }
}

export default Slot;
